import { render, staticRenderFns } from "./roomDetailHis.vue?vue&type=template&id=f95a23b4&scoped=true"
import script from "./roomDetailHis.vue?vue&type=script&lang=js"
export * from "./roomDetailHis.vue?vue&type=script&lang=js"
import style0 from "./roomDetailHis.vue?vue&type=style&index=0&id=f95a23b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95a23b4",
  null
  
)

export default component.exports